import { useQuery } from "@msuite/ui/query";
import { client } from "@/hono";

/**
 * The rendered PDF label for one trolley.
 *
 * `responseHandler` is deliberately not used here, and this is the one hook in the app that skips
 * it: the route answers PDF bytes rather than the `{ success, … }` envelope every other route
 * answers, so there is no body for it to read a failure out of. The status is what reports failure
 * instead, and the thrown error is what the card renders its own message from.
 *
 * The label is derived from the carrier row, so it is stale exactly when that row is — the query
 * key names the carrier and invalidating `transfer-carrier` alongside it after an edit is what
 * reprints a renamed device.
 */
export function useTransferCarrierLabel(transferCarrierId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["transfer-carrier-label", transferCarrierId],
		queryFn: async () => {
			const response = await client.stock["transfer-carriers"][":transferCarrierId"].label.$get({
				param: { transferCarrierId },
			});
			if (!response.ok) throw new Error("Could not render the transfer carrier label");
			return await response.blob();
		},
	});

	/** Return */
	return { ...query, label: query.data ?? null };
}
